import { useRef, useEffect } from "react";
import { toast } from "sonner";
import { Bold, Italic, Heading2, Heading3, List, Link2, ImagePlus } from "lucide-react";
import { api, resolveImg } from "@/lib/api";

export default function RichTextEditor({ value, onChange }) {
  const ref = useRef(null);
  const fileRef = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInput = () => onChange(ref.current?.innerHTML || "");

  const exec = (cmd, arg = null) => {
    ref.current?.focus();
    document.execCommand(cmd, false, arg);
    handleInput();
  };

  const addLink = () => {
    const url = window.prompt("Adresa link-ului (https://...)");
    if (url) exec("createLink", url);
  };

  const uploadImg = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload-image", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      exec("insertImage", resolveImg(data.url));
      toast.success("Imagine inserată");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Eroare la încărcare");
    } finally {
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const Btn = ({ onClick, title, testId, children }) => (
    <button
      type="button"
      onClick={onClick}
      title={title}
      data-testid={testId}
      className="w-9 h-9 flex items-center justify-center rounded-md text-slate-600 hover:bg-white hover:text-[#FF5A1F] transition-colors duration-200"
    >
      {children}
    </button>
  );

  return (
    <div className="border border-[#E2E8F0] rounded-lg overflow-hidden">
      <div className="flex items-center gap-1 border-b border-[#E2E8F0] bg-slate-50 px-2 py-1 flex-wrap">
        <Btn onClick={() => exec("bold")} title="Îngroșat" testId="editor-bold"><Bold className="w-4 h-4" /></Btn>
        <Btn onClick={() => exec("italic")} title="Italic" testId="editor-italic"><Italic className="w-4 h-4" /></Btn>
        <Btn onClick={() => exec("formatBlock", "<h2>")} title="Titlu secțiune" testId="editor-h2"><Heading2 className="w-4 h-4" /></Btn>
        <Btn onClick={() => exec("formatBlock", "<h3>")} title="Subtitlu" testId="editor-h3"><Heading3 className="w-4 h-4" /></Btn>
        <Btn onClick={() => exec("insertUnorderedList")} title="Listă" testId="editor-list"><List className="w-4 h-4" /></Btn>
        <Btn onClick={addLink} title="Inserează link" testId="editor-link"><Link2 className="w-4 h-4" /></Btn>
        <Btn onClick={() => fileRef.current?.click()} title="Inserează imagine" testId="editor-image"><ImagePlus className="w-4 h-4" /></Btn>
        <input ref={fileRef} type="file" accept=".jpg,.jpeg,.png,.gif,.webp" onChange={uploadImg} className="hidden" />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        data-testid="article-content-editor"
        className="article-body min-h-[260px] max-h-[460px] overflow-y-auto p-4 text-sm text-[#0F1E36] focus:outline-none"
      />
    </div>
  );
}
